//#Global Imports
import React from "react";
//#end Global Imports

//#Local Imports
import Button from "../../components/ui/Button";
import Typograpy from "../../components/ui/Typography";
import { IRemitterProps } from "./Remmiter";
import TrashBin from "../../assets/Icons/TrashBin";
import { CopyIcon } from "../../assets/Icons";
import ShareWhite from "../../assets/svg/share-white.svg"
import { set } from "cypress/types/lodash";
import MixpanelConfig from "../../constants/MixpanelConfig";
//#end Local Imports

const RemitterDetails: React.FC<IRemitterProps.IRemitterDetailsProps> = ({
  remitterData,
  deleteRemitterHandler,
  handleTransactionUpdate,
  handleSelectedRemitter,
  handleResendKycLink,
  handleResendLink,
  catchKycLink,
  showToast,
  selectRemitterHandler
}) => {

  const handleCopy = () => {
    if (catchKycLink) {
      navigator.clipboard.writeText(catchKycLink)
        .then(() => {
          // Optionally, show a success message to the user
          showToast && showToast("KYC Link Copied", "success")
        })
        .catch(err => {
          console.error('Failed to copy text: ', err);
          // Optionally, show an error message to the user
          showToast && showToast("KYC Link not Copied", "failure")
        });
    }
  };

  return (
    <div onClick={() => handleSelectedRemitter(remitterData?.id)} className="bg-[#F0F5FF]">
      <div className={` p-3 grid grid-cols-11`}>
          <div className={`flex flex-col gap-4 ${remitterData?.isDocVerified ? "col-span-9":"col-span-7"} `}>
            <div className="flex items-center gap-9">
            <div className="flex items-center gap-1">
              <Typograpy
                tagType="div"
                text="Date of Birth : "
                className="text-sm font-normal text-black"
                />
              <Typograpy
                tagType="div"
                text={remitterData?.dob}
                className="text-sm font-normal text-black"
                />
            </div>
            </div>
            <div className={remitterData?.isDocVerified ? "flex items-center gap-1": "flex items-center gap-1"}>
              <Typograpy tagType="div" text="City : " className="text-sm font-normal text-black" />
              <Typograpy
                tagType="div"
                text={remitterData?.city}
                className="text-sm font-normal text-black"
              />
            </div>
            <div className="flex items-center gap-1">
              <Typograpy
                tagType="div"
                text="Address : "
                className="text-sm font-normal text-black"
              />
              <Typograpy
                tagType="div"
                text={
                  [
                    remitterData?.addressLine1?.trim(),
                    remitterData?.addressLine2?.trim()
                  ]
                    .filter(Boolean) 
                    .join(", ")
                }
                title={
                  [
                    remitterData?.addressLine1?.trim(),
                    remitterData?.addressLine2?.trim()
                  ]
                    .filter(Boolean) 
                    .join(", ")
                }
                className="text-sm font-normal text-black break-words cursor-pointer"
              />
            </div>
          </div>
    

          {!remitterData?.isDocVerified ? (
              <div className="flex flex-col items-start gap-2 col-span-2 ml-[30%]">
                <p className="text-xs font-normal text-black text-wrap max-w-[100px]">
                  Share link to complete KYC{" "}
                </p>
                <div className="flex items-center gap-2">
                  <Button
                    bgColor="bg-transparent"
                    fontStyle={{
                      fontFamily: "font-ssp",
                      fontSize: "text-sm",
                      fontWeight: "font-semibold",
                      fontColor: "text-[#006EFF]",
                    }}
                    borderStyle={{
                      borderRadius:"rounded-md",
                      borderColor:"border-[#006EFF]",
                      borderWidth:"border"
                    }}
                    className="p-1"
                    onClickHandler={() => {
                      handleResendKycLink(remitterData?.userKey)
                      showToast && showToast("KYC Link Sent to email and phone number of the remitter", "success")
                    }}
                  >
                    Send
                  </Button>
                  <div className="cursor-pointer" onClick={handleCopy}>
                  <Button
                    bgColor="bg-transparent"
                    fontStyle={{
                      fontFamily: "font-ssp",
                      fontSize: "text-sm",
                      fontWeight: "font-semibold",
                      fontColor: "text-[#006EFF]",
                    }}
                    borderStyle={{
                      borderRadius:"rounded-md",
                      borderColor:"border-[#006EFF]",
                      borderWidth:"border"
                    }}
                    className="p-1"
                    onClickHandler={() => {
                      handleResendKycLink(remitterData?.userKey)
                      showToast && showToast("KYC Link Sent to email and phone number of the remitter", "success")
                    }}
                  >
                    Copy
                  </Button>
                  </div>
                </div>

              </div>
          ) : null}

          <div className="flex flex-col items-start  gap-2 cursor-pointer col-span-2 ml-[7%]">
              <Button
                    bgColor="bg-[#006EFF]"
                    fontStyle={{
                      fontFamily: "font-ssp",
                      fontSize: "text-base",
                      fontWeight: "font-semibold",
                      fontColor: "text-white",
                    }}
                    borderStyle={{
                      borderRadius: "rounded-md",
                    }}
                    className="p-1"
                    onClickHandler={() => {
                      selectRemitterHandler(remitterData?.id)  
                      MixpanelConfig.trackEvent(MixpanelConfig.eventNames.Old_Remitter_Select, { 
                        selectedRemitter: remitterData
                      }); 
                      setTimeout(() => {
                        handleTransactionUpdate();
                      }, 500);
                      showToast && showToast("Remitter Selected", "success")
                    }}
                  >
                    Select Remitter
                  </Button>
                  <div onClick={() => deleteRemitterHandler(remitterData?.id)} className="cursor-pointer hover:scale-105 transition-transform duration-200">
                    <p className="text-sm text-red-200 underline">Delete Remitter</p>
                  </div>
        </div>
        </div>
      </div>
  );
};
export default RemitterDetails;
